import api from '../api.js';

export const expenseRequests = {
  getAllByMonthAndYear: (month, year) => {
    return api.get(`/expenses/filter?month=${month}&year=${year}`, { cache: 'no-store' });
  },
  getById: (id) => {
    return api.get(`/expenses/${id}`, { cache: 'no-store' });
  },
  create: (expensesDto) => {
    return api.post(`/expenses`, expensesDto);
  },
  update: (expensesDto, id) => {
    return api.put(`/expenses/${id}`, expensesDto);
  },
  delete: (id) => {
    return api.delete(`/expenses/${id}`);
  },
};

export default expenseRequests;
